import Services from './base-services'

const service = new Services('analyticEvents')

export default {
  createEvent(payload: object) {
    return service.contentPost('user_events', payload)
  },
}
